module.exports = __webpack_public_path__ + "img/home_img_jj.c126539e.png";